'use client';

// Package Imports
import React from 'react';

// Type Imports
import type { WithContext, BreadcrumbList } from 'schema-dts';

type BreadcrumbSchemaProps = {
  items: { label: string; href: string }[];
};

const siteUrl = (process.env.NEXT_PUBLIC_SITE_URL ?? '').replace(/\/$/, '');

const BreadcrumbSchema = ({ items }: BreadcrumbSchemaProps) => {
  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    ...items,
  ];

  const schema: WithContext<BreadcrumbList> = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: `${siteUrl}${item.href.replace(/\/$/, '')}`,
    })),
  };

  return <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
};

export default BreadcrumbSchema;
